module.exports = {"Logout5":{"daobanList":[{"title":"1:个体工商户注销需提交什么材料","values":[{"name":"《个体工商户登记（备案）申请书》","xuanzhong":1,"cailiaoList":[{"name":"《个体工商户登记（备案）申请书》","state":"必要"}]},{"name":"清税证明材料（登记机关和税务部门已共享清税信息的，无需提交纸质清税证明材料）","xuanzhong":0,"cailiaoList":[{"name":"清税证明材料（登记机关和税务部门已共享清税信息的，无需提交纸质清税证明材料）","state":"必要"}]},{"name":"已领取纸质版营业执照的缴回营业执照正、副本","xuanzhong":0,"cailiaoList":[{"name":"已领取纸质版营业执照的缴回营业执照正、副本","state":"必要"}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sdl-5.json
// module id = 1264
// module chunks = 0